var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'list')?_c('v-skeleton-loader',{staticClass:"px-6",attrs:{"type":"list-item@4"}}):_c('v-skeleton-loader',{staticClass:"px-6",attrs:{"type":"table-heading, table-thead, table-row@4, table-tfoot"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }